// Live password-policy checklist (mirrors the server policy: 12+ chars,
// upper, lower, number). Purely advisory — the server re-validates.
import { Check, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function passwordMeetsPolicy(pw: string): boolean {
  return pw.length >= 12 && /[A-Z]/.test(pw) && /[a-z]/.test(pw) && /\d/.test(pw);
}

export function PasswordPolicy({ password, variant = 'glass' }: { password: string; variant?: 'glass' | 'paper' }) {
  const { t } = useTranslation('auth');

  const rules: Array<[string, boolean]> = [
    [t('forceChange.policy.minLength'), password.length >= 12],
    [t('forceChange.policy.upper'), /[A-Z]/.test(password)],
    [t('forceChange.policy.lower'), /[a-z]/.test(password)],
    [t('forceChange.policy.number'), /\d/.test(password)],
  ];

  const okColor = variant === 'glass' ? 'text-emerald-300' : 'text-emerald-600';
  const badColor = variant === 'glass' ? 'text-white/40' : 'text-slate-400';

  return (
    <ul className="grid grid-cols-2 gap-x-4 gap-y-1.5">
      {rules.map(([label, ok]) => (
        <li key={label} className={`flex items-center gap-1.5 text-xs ${ok ? okColor : badColor}`}>
          {ok ? <Check className="w-3.5 h-3.5 shrink-0" /> : <X className="w-3.5 h-3.5 shrink-0" />}
          {label}
        </li>
      ))}
    </ul>
  );
}
